import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams } from "../http-params.util";

/**
 * EmailStatusApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/emailStatusApi/emailStatusApi.service.js.
 *
 * Bug fix: the legacy `list()` referenced `this.server.tenant` instead of
 * `this.service.tenant` (typo — `server` was never defined). Any caller would
 * have thrown `TypeError: Cannot read properties of undefined (reading
 * 'tenant')`. The migrated `list()` issues the GET that was clearly intended.
 */
const EMAIL_STATUS_TENANT_BASE = "/v1/api/email/status";
const EMAIL_STATUS_ORDER_BASE = "/v1/api/email/status/order";

const EMAIL_STATUS_FIELDS = [
  "email",
  "type",
  "status",
  "sortDirection",
  "sortField",
  "pageSize",
  "page",
] as const;

@Injectable({ providedIn: "root" })
export class EmailStatusApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(EMAIL_STATUS_TENANT_BASE, {
        params: buildParams(props, EMAIL_STATUS_FIELDS),
      }),
    );
  }

  detail(
    id: number | string,
    props?: Record<string, unknown>,
  ): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(`${EMAIL_STATUS_ORDER_BASE}/${id}`, {
        params: buildParams(props, EMAIL_STATUS_FIELDS),
      }),
    );
  }
}
